import { computed, Injectable, Signal, signal } from "@angular/core";
import { AcceptMarginOfferMutation } from "../../../api/graphql/offer/generated/margin-trading.offer.accept.service.graphql-gen";
import { Fiat } from "@models";
import { Tradable } from "@models/interfaces/tradable";
import { AssetFragment } from "../../../api/graphql/bff/generated/fragments.service.graphql-gen";

export interface MarginSuccessSummaryViewModel {
	acceptedOffer: AcceptMarginOfferMutation["acceptMarginOffer"];
	fiat: Fiat;
	tradable: Tradable;
	assetInfo: AssetFragment;
}
@Injectable({
	providedIn: "root"
})
export class MtSuccessState {
	private _acceptedOffer$ = signal<AcceptMarginOfferMutation["acceptMarginOffer"] | null>(null);
	private _fiat$ = signal<Fiat | null>(null);
	private _tradable$ = signal<Tradable | null>(null);
	private _assetInfo$ = signal<AssetFragment | null>(null);
	public viewModel$: Signal<MarginSuccessSummaryViewModel> = computed(() => {
		return {
			acceptedOffer: this._acceptedOffer$(),
			fiat: this._fiat$(),
			tradable: this._tradable$(),
			assetInfo: this._assetInfo$()
		};
	});

	public setVm(
		acceptMarginOffer: AcceptMarginOfferMutation["acceptMarginOffer"],
		fiat: Fiat,
		tradable: Tradable,
		assetInfo: AssetFragment
	): void {
		this._acceptedOffer$.set(acceptMarginOffer);
		this._fiat$.set(fiat);
		this._tradable$.set(tradable);
		this._assetInfo$.set(assetInfo);
	}
}
